import BaseService from './baseService';

class Transaction extends BaseService {
	async getTransactionBySubmissionId(id,opts = {}) {
    this.endPoint = '/transaction/'+id;
		return this.get(opts);
  }
  async createTransaction(payload){
    this.endPoint = '/transaction';
    return await this.post(payload); 
  }
  // async updatePemasukan(id,payload,opts={}){
  //   this.endPoint = '/submission';
  //   return await this.putOne(id,payload,opts);
  // }
  async deleteTransaction(id,opts={}){
    this.endPoint = '/transaction';
    return await this.delete(id,opts);
  }
}

export default new Transaction();